<template>
  <div class="details-view">
    <cargo-left-right-resize
      ref="cargoLeftRightResize"
      :left-style="{flex:'none','max-width':'190px'}"
      :right-style="{'overflow': 'hidden'}"
      :show-left="action==='look'"
      style="min-height:100%"
    >
      <template v-show="action==='look'" slot="left">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :row-data="rowData"
          class="section"
          style="width: 100%;min-width: 160px;height: 100%;"
          @gridReady="params=>{gridApi=params.api}"
        />
      </template>
      <template slot="right">
        <div class="main-content">
          <div class="operations" style="margin-bottom: 5px">
            <div class="triggers">
              <cargo-button-group-slider ref="cargoButtonGroupSlider">
                <div v-show="action==='look'" :class="'btn-group-look' + (canOperateJob ? '' : ' cannot-operate-job')">
                  <el-button no="back" type="primary" class="can-operate" @click="goBack">{{ $t('common.btn.back') }}</el-button>
                  <el-button v-if="canEditByPermission" no="edit" :disabled="!(job && Number(job.jobState) === 0 && !JobUtils.isBlockJob(job))" type="success" @click="editEventFlag=true">{{ $t('common.btn.edit') }}</el-button>
                </div>
                <div v-show="isNew" class="new btn-group-new" style="border-left:none;padding-left:0">
                  <el-button no="save" type="success" @click="save">{{ $t('common.btn.save') }}</el-button>
                  <el-button no="cancel" type="success" @click="cancelEdit(goBack)">{{ $t('common.btn.cancel') }}</el-button>
                  <el-button
                    no="SaveTheDefaultValues"
                    type="primary"
                    @click="saveDefaultVal"
                  >{{ $t('SeaExport.SaveTheDefaultValues') }}</el-button>
                </div>
                <div v-show="action==='edit'" class="btn-group-edit" style="border-left:none;padding-left:0">
                  <el-button no="save2" type="success" @click="save">{{ $t('common.btn.save') }}</el-button>
                  <el-button
                    no="cancel2"
                    type="success"
                    @click="cancelEdit(lookHandler)"
                  >{{ $t('common.btn.cancel') }}</el-button>
                  <el-button
                    no="SaveTheDefaultValues2"
                    type="primary"
                    @click="saveDefaultVal"
                  >{{ $t('SeaExport.SaveTheDefaultValues') }}</el-button>
                </div>
              </cargo-button-group-slider>
            </div>
            <div v-show="action==='look'||action==='edit'" class="triggers-right">
              <!-- im入口 -->
              <CargoIm v-show="imCacheKey && action==='look'" ref="cargoIm" />
              <el-tooltip
                effect="dark"
                :content="action==='edit' ? '' : $t('SeaExport.Tip1')"
                placement="bottom-start"
                :offset="sopTooltipOffset"
                :visible-arrow="false"
              >
                <div
                  style="width: 100%;cursor: pointer"
                  @mousemove="resetSopTooltip"
                  @dblclick="onBtnListDoubleClicked"
                >
                  <span no="SopState" style="font-size:14px;color:red;padding:5px 0">
                    {{ stateInfo.jobState }}
                    <!-- 「正操作」「预提交」「已提交」「已审核」业务状态存在费用时 进行退关操作后，需要显示为「XXX（有费用退关）」-->
                    <font v-if="(Number(currentRow.jobState) === 0 || Number(currentRow.jobState) === 1 || Number(currentRow.jobState) === 2 || Number(currentRow.jobState) === 11) && currentRow.shutOut && !stateInfo.jobChangeState" class="red" style="font-size:14px;">({{ $t('Message.HasChargeToShutOut') }})</font>
                    <font v-if="(Number(currentRow.jobState) === 0 || Number(currentRow.jobState) === 1 || Number(currentRow.jobState) === 2 || Number(currentRow.jobState) === 11) && currentRow.shutOut && stateInfo.jobChangeState" class="red" style="font-size:14px;">({{ $t('Message.HasChargeToShutOut') }}/{{ stateInfo.jobChangeState }})</font>
                    <font v-if="!((Number(currentRow.jobState) === 0 || Number(currentRow.jobState) === 1 || Number(currentRow.jobState) === 2 || Number(currentRow.jobState) === 11) && currentRow.shutOut) && stateInfo.jobChangeState" class="red" style="font-size:14px;">({{ stateInfo.jobChangeState }})</font>
                    <span v-if="job.payableChargeLockedStatus === 1" class="red" style="margin: 0px 0px 0px 0px;">{{ $t('CargoMsg.Cargo_PayableLockedStatusTag') }}<el-tooltip effect="dark" :content="payableChargeLockedTooltip" placement="bottom" :visible-arrow="false"><i class="el-icon-warning" style="cursor:pointer;" /></el-tooltip></span>
                  </span>
                  <span
                    style="font-size:12px;padding: 5px 9px;color:unset;"
                    v-html="stateInfo.jobTitle"
                  />
                  <span style="font-size:12px;color:red;padding:5px 0">{{ stateInfo.jobLock }}</span>
                  <span v-if="stateInfo.provisionLock && stateInfo.provisionLock.etdLocked" style="font-size:14px;color:red;margin-left:10px;">计提已校准</span>
                </div>
              </el-tooltip>
              <el-tooltip v-if="currentRow.zyCreditWarning" effect="dark" :content="currentRow.zyCreditWarning" placement="bottom-start" :visible-arrow="false">
                <div class="right-tip" style="cursor:pointer;font-size:12px;color:orange;width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
                  <span>{{ currentRow.zyCreditWarning }}</span>
                </div>
              </el-tooltip>
            </div>
          </div>
          <div :class="'tabs-container' + (canOperateJob ? '' : ' cannot-operate-job')">
            <el-tabs
              ref="tabs"
              v-model="activeTabName"
              type="card"
              :before-leave="(activeName,oldActiveName)=>{beforeLeaveTab(activeName,oldActiveName)}"
              style="width:100%;"
              @tab-click="handleTabClick"
            >
              <el-tab-pane
                v-if="!masterFlag && privilege.reBooking.bookingTab"
                :key="1"
                :lazy="true"
                name="tabBookingFCL"
                :label="$t('SeaExport.Basic')"
              >
                <tab-booking-FCLUICustom
                  v-if="$store.state.uiCustom.enable && !isFba"
                  ref="tabBookingFCL"
                  :context="context"
                  :action="action"
                  :is-fba="isFba"
                  :cooperate-edit="cooperateEditOther"
                  view-source="bookingWorkspace"
                  :processing-promise-list="processingPromiseList"
                  :template-name="templateName"
                  @resetTab="resetTab"
                />
                <tab-booking-fcl
                  v-else
                  ref="tabBookingFCL"
                  :context="context"
                  :action="action"
                  :is-fba="isFba"
                  :cooperate-edit="cooperateEditOther"
                  view-source="bookingWorkspace"
                  :processing-promise-list="processingPromiseList"
                  :template-name="templateName"
                  :provision-lock="stateInfo.provisionLock"
                  @resetTab="resetTab"
                />
              </el-tab-pane>
              <el-tab-pane
                v-if="masterFlag && privilege.reBooking.bookingTab"
                :key="2"
                :lazy="true"
                name="tabBookingMaster"
                :label="$t('SeaExport.Basic')"
              >
                <tab-booking-master-UICustom
                  v-if="$store.state.uiCustom.enable && !isFba"
                  ref="tabBookingMaster"
                  :context="context"
                  :action="action"
                  :is-fba="isFba"
                  view-source="bookingWorkspace"
                  :cooperate-edit="cooperateEditOther"
                  :template-name="templateName"
                  @addLcl="addBatchLcl"
                  @selectJob="transferTargetRow"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @removeJob="removeJob"
                  @resetTab="resetTab"
                />
                <tab-booking-master
                  v-else
                  ref="tabBookingMaster"
                  :context="context"
                  :action="action"
                  :is-fba="isFba"
                  view-source="bookingWorkspace"
                  :cooperate-edit="cooperateEditOther"
                  :template-name="templateName"
                  @addLcl="addBatchLcl"
                  @selectJob="transferTargetRow"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @removeJob="removeJob"
                  @resetTab="resetTab"
                />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.warehousing && privilege.reBooking.warehouseTab"
                :key="3"
                :lazy="true"
                name="tabWarehouse"
                :label="$t('SeaExport.WarehouseLoading')"
              >
                <tab-warehouse ref="tabWarehouse" :context="context" :action="action" :cooperate-edit="cooperateEditWarehouse" />
              </el-tab-pane>
              <el-tab-pane v-if="!isNew && isFba && !masterFlag && paramsOfTab.warehousing && $checkPermission(['tab_FBARailwayExport_fbaRailWarehouseTab'])" :key="29" :label="$t('RailwayExport.DomesticWarehouse')" :lazy="true" name="fbaWarehousingDetail">
                <!-- 国内仓 -->
                <fba-warehousing-detail ref="fbaWarehousingDetail" lob="FBA" :action="action" source="fbaRailway" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <el-tab-pane v-if="!isNew && isFba && !masterFlag && $checkPermission(['tab_FBARailwayExport_fbaRailoverSeaWarehouseTab'])" :key="30" :label="$t('RailwayExport.OverseasWarehouse')" :lazy="true" name="fbaOutWarehouse">
                <!-- 国外仓 -->
                <fba-out-warehouse ref="fbaOutWarehouse" :action="action" :context="context" source="fbaRailway" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.landTransportation && privilege.reBooking.reTruckingPage"
                :key="4"
                :lazy="true"
                name="tabTrucking"
                :label="$t('SeaExport.Trucking')"
              >
                <tab-trucking ref="tabTrucking" :context="context" :action="action" :cooperate-edit="cooperateEditTrucking" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !masterFlag && privilege.reBooking.containersLayer"
                :key="5"
                :lazy="true"
                name="tabContainer"
                :label="$t('SeaExport.ContainerInfo')"
              >
                <tab-container ref="tabContainer" :context="context" :action="action" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && masterFlag && !isNew && privilege.reBooking.lclManagerLayer"
                :key="6"
                :lazy="true"
                name="tabLclContainer"
                :label="$t('SeaExport.ContainerInfo')"
              >
                <tab-lcl-container
                  ref="tabLclContainer"
                  :context="context"
                  :action="action"
                  :cooperate-edit="cooperateEditOther"
                  :location="location"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @split="splitHandle"
                />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && privilege.charge.chargeView && !isFba"
                :key="7"
                :lazy="true"
                name="tabTradeDetail"
                :label="$t('SeaExport.TradeDetail')"
              >
                <tab-trade-detail ref="tabTradeDetail" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane v-if="!isNew && isFba && !masterFlag && $checkPermission(['tab_FBARailwayExport_fbaRailGoodsDetailTab'])" :key="31" :label="$t('SeaExport.TradeDetail')" :lazy="true" name="fbaGoodsDetail">
                <!-- fba货物明细 -->
                <tab-warehousing-detail ref="fbaGoodsDetail" :context="context" :action="action" source="fbaRailway" :cooperate-edit="cooperateEditOther" :is-uppercase-by-config="isUppercaseByConfig" @reload="reload" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.customs && privilege.reBooking.reCustomsInfo && !tabInfo.visible.oujianCustomsInfo"
                :key="8"
                :lazy="true"
                name="tabCustomsInfo"
                :label="$t('SeaExport.CustomsDeclaration')"
              >
                <tab-customs-info ref="tabCustomsInfo" :context="context" :action="action" :cooperate-edit="cooperateEditCustoms" />
              </el-tab-pane>
              <!-- 保险 -->
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && paramsOfTab.insure"
                :lazy="true"
                name="tabInsure"
                :label="$t('SeaExport.InsureInfo')"
              >
                <tab-insure ref="tabInsure" :context="context" :action="action" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.itmService"
                :key="9"
                :lazy="true"
                name="tabTradeCommission"
                :label="$t('SeaExport.TradeCommission')"
              >
                <tab-trade-commission ref="tabTradeCommission" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.headwayTail && privilege.reBooking.headwayTail"
                :key="10"
                :lazy="true"
                name="tabRailwayHeadwayTail"
                :label="$t('RailwayExport.isHeadwayTail')"
              >
                <tab-railway-headway-tail
                  ref="tabRailwayHeadwayTail"
                  :context="context"
                  :action="action"
                  :cooperate-edit="cooperateEditOther"
                />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && privilege.charge.chargeView"
                :key="11"
                :lazy="true"
                name="tabCharges"
                :label="$t('SeaExport.Charge')"
              >
                <tab-charges ref="tabCharges" :context="context" :action="action" :location="location" view-source="RailwayBooking" :provision-lock="stateInfo.provisionLock" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && privilege.chargeConfirm.chargeConfirmView"
                :key="12"
                :lazy="true"
                name="tabInternalBill"
                :label="$t('SeaExport.InternalBillInfo')"
              >
                <tab-internal-bill ref="tabInternalBill" :context="context" :action="action" :location="location" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && privilege.billTab.billTabView"
                :key="13"
                :lazy="true"
                name="tabOverseaBill"
                :label="$t('SeaExport.OverseaBillInfo')"
              >
                <tab-oversea-bill ref="tabOverseaBill" :context="context" :action="action" :location="location" view-source="RailwayBooking" @refreshCharges="refreshCharges" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && privilege.charge.advanceCharge"
                :key="14"
                :lazy="true"
                name="tabAdvanceCharge"
                :label="$t('SeaExport.AdvanceChargeInfo')"
              >
                <tab-advance-charge ref="tabAdvanceCharge" :context="context" :action="action" :location="location" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && privilege.reBooking.portalState && !isNew"
                :key="15"
                :lazy="true"
                name="tabSopState"
                :label="$t('SeaExport.BusinessStatus')"
              >
                <tab-sop-state ref="tabSopState" :context="context" :action="action" :cooperate-edit="cooperateEditOther" :controlled-locked="controlledLocked" :sop-template-config="sopTemplateConfig" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && privilege.fileHistory.fileHistoryView"
                :key="16"
                :lazy="true"
                name="tabFileHistory"
                :label="$t('SeaExport.FileHistory')"
              >
                <tab-file-history ref="tabFileHistory" :context="context" :cooperate-edit="cooperateEditOther" :can-operate-job="canOperateJob" :controlled-locked="controlledLocked" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <!-- 退关弹窗 -->
    <el-dialog
      v-el-drag-dialog
      no="shutOut"
      :visible.sync="shutOutDialog.visible"
      :title="$t('Message.Warning')"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="display: flex;flex-direction: column;padding-left:30px">
        <span style="line-height: 40px;">{{ $t('Message.PleaseConfirmTheShutOut') }}</span>
        <span style="line-height: 18px;">{{ shutOutDialog.shutOutTip1 }}</span>
        <span style="line-height: 18px;">{{ shutOutDialog.shutOutTip2 }}</span>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button
          no="HasChargeToShutOut"
          type="primary"
          @click="pm.hasChargeShutoutHandler()"
        >{{ $t('Message.HasChargeToShutOut') }}</el-button>
        <el-button
          no="NoChargeToShutOut"
          :style="{ display: shutOutDialog.shutOutButtonShow2 }"
          type="primary"
          @click="pm.noHasChargeShutoutHandler()"
        >{{ $t('Message.NoChargeToShutOut') }}</el-button>
        <el-button no="cancel" @click="shutOutDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- SOP操作状态弹窗 -->
    <sop-state-dialog
      :hide-window="action!=='look'"
      :visible.sync="sopStateDialog.visible"
      :is-need-refresh.sync="sopStateDialog.isNeedRefresh"
      :job="currentRow"
      :default-is-expand="sopStateDialog.defaultIsExpand"
      :is-need-expand.sync="sopStateDialog.isNeedExpand"
      @handleClose="sopStateDialogClose"
    />
    <!-- 预估利润率验证弹窗-->
    <estimate-validation-dialog
      :visible.sync="estimateValidationDialog.visible"
      :job="estimateValidationDialog.job"
      :estimate-profit-rate="estimateValidationDialog.estimateProfitRate"
      :tatol-profit="estimateValidationDialog.tatolProfit"
      @callback="estimateValidationDialog.callback"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      lob="RE"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />
    <!-- 单条业务 配置规则验证弹窗-->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      lob="RE"
      :job="currentRow"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
      :call-back2="checkingWindow.callBack2"
    />
    <!-- 数据推送变更记录弹窗 -->
    <el-dialog
      v-if="dataPushDialog.visible"
      v-el-drag-dialog
      no="DataPushChangeLog"
      :visible.sync="dataPushDialog.visible"
      :title="$t('SeaExport.DataPushChangeLog')"
      width="580px"
      :close-on-click-modal="false"
      class="app-main-inner"
      @close="dataPushDialog.visible=false"
    >
      <div
        class="app-main-inner-row"
        style="padding: 0;display: flex;flex-direction: column"
        :style="{width:'100%',height:'400px',overflow:'auto'}"
      >
        <div v-for="(title,index) in dataPushDialog.titles" :key="index">
          <div style="background:#EBECF5">
            <b>{{ title }}</b>
          </div>
          <div v-for="(item,index) in dataPushDialog.dataMap.get(title)" :key="index">
            <div>{{ item }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 业务状态变更记录弹窗 -->
    <business-status-log-dialog
      v-if="businessStatusDialog.visible"
      :visible.sync="businessStatusDialog.visible"
      :job-uuid="currentRow.uuid || ''"
    />
    <!-- EDI状态变更记录弹窗 -->
    <edi-status-log-dialog
      v-if="ediStatusLogDialog.visible"
      :visible.sync="ediStatusLogDialog.visible"
      :job-uuid="currentRow.uuid || ''"
    />
    <!--选择协作分公司-->
    <cooperation-branch-list
      v-if="cooperationBranchListDialog.visible"
      :visible.sync="cooperationBranchListDialog.visible"
      :job-uuid="cooperationBranchListDialog.jobUuid"
      :job="cooperationBranchListDialog.job"
      :order-center-branch="cooperationBranchListDialog.orderCenterBranch"
      @refresh="(cooperatebranch)=>{updateJobCooperate(cooperatebranch);this.$refs.tabCharges.refreshCooperatebranch(cooperatebranch)}"
      @cancel="()=>cooperationBranchListDialog.visible=false"
    />
    <!-- 验证规则-保存业务节点弹窗 -->
    <checking-save-job-window
      v-if="checkingSaveJobWindow.visible"
      :visible.sync="checkingSaveJobWindow.visible"
      lob="AE"
      :row-data="checkingSaveJobWindow.rowData"
      :check-node="checkingSaveJobWindow.checkNode"
      :call-back="checkingSaveJobWindow.callBack"
    />
    <!-- 发送分公司/tenant内部委托 -->
    <el-dialog
      v-if="sendBranchWindow.visible"
      v-el-drag-dialog
      :visible.sync="sendBranchWindow.visible"
      :title="sendBranchWindow.title"
      width="360px"
      :close-on-click-modal="false"
    >
      <el-form label-width="85px" label-position="left">
        <el-form-item :label="$t('SeaExport.CustomerService') + ':'">
          <cargo-user-select
            :method-params="{officeId: sendBranchWindow.office.officeId, category:'role', shape: 'csr' }"
            @change="p=>{sendBranchWindow.userId=p.value;userId_changeHandler()}"
          />
        </el-form-item>
        <el-form-item v-if="showdCheckSalesMapping" :label="$t('queryJob.SalesMapping')">
          <el-checkbox v-model="sendBranchWindow.checkSalesMapping" no="checkSalesMapping">{{ $t('queryJob.SalesCargoSalesMap') }}</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="enterSendHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="sendBranchWindow.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!--关联业务信息-->
    <trust-from-window
      v-if="trustFromWindow.visible"
      ref="trustFromWindow"
      :visible.sync="trustFromWindow.visible"
      :trust-job="trustFromWindow.trustJob"
      :context="context"
      :can-operate-job="canOperateJob"
    />
    <!-- 业务申请审批流 -->
    <job-apply-dialog
      v-if="jobApplyDialog.visible"
      :visible.sync="jobApplyDialog.visible"
      :title="$t('CargoMsg.Cargo_SubmitJobChargeForApproval')"
      type="apply"
      :doc-id="currentRow.uuid"
      :document-config-id="documentConfigId"
      @close="jobApplyDialog.visible=false"
      @closeAndRefresh="applyCloseAndRefresh"
    />
    <job-return-review-dialog
      v-show="returnReviewDialog.visible"
      :visible.sync="returnReviewDialog.visible"
      :lob="currentRow.lob"
      :selected-jobs="returnReviewDialog.selectedJobs"
      srouce="detail"
      @confirm="reload"
    />
    <!-- 变更日志记录 弹窗 -->
    <data-update-log-dialog :hide-window="isEditing" :visible.sync="dataUpdateLogDialog.visible" :is-need-refresh.sync:="dataUpdateLogDialog.isNeedRefresh" :default-is-expand="dataUpdateLogDialog.defaultIsExpand" :job="job" :is-need-expand.sync="dataUpdateLogDialog.isNeedExpand" @handleClose="dataUpdateLogDialogClose" />
  </div>
</template>

<script>
import { BookingWorkspaceContext } from '@/views/cargo/v0/RailwayExport/components/booking/bookingWorkspaceContext'
import { BookingWorkspacePM } from '@/views/cargo/v0/RailwayExport/components/booking/bookingWorkspacePM'

import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import tabBookingFcl from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabBookingFCL'
import tabBookingFCLUICustom from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabBookingFCLUICustom'
import tabBookingMaster from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabBookingMaster'
import tabBookingMasterUICustom from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabBookingMasterUICustom'
import tabWarehouse from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabWarehouse'
import tabTrucking from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabTrucking'
import tabContainer from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabContainer'
import tabLclContainer from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabLclContainer'
import tabTradeDetail from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabTradeDetail'
import tabCustomsInfo from '@/components/Cargo/Job/booking/tabs/tabCustomsInfo'
import tabTradeCommission from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabTradeCommission'
import tabRailwayHeadwayTail from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabRailwayHeadwayTail'
import tabCharges from '@/components/Cargo/Job/booking/tabs/tabCharges'
import tabInternalBill from '@/components/Cargo/Job/booking/tabs/tabInternalBill'
import tabOverseaBill from '@/components/Cargo/Job/booking/tabs/tabOverseaBill'
import tabAdvanceCharge from '@/components/Cargo/Job/booking/tabs/tabAdvanceCharge'
import tabSopState from '@/components/Cargo/Job/booking/tabs/tabSopState'
import tabFileHistory from '@/components/Cargo/Job/booking/tabs/tabFileHistory'
import sopStateDialog from '@/components/Cargo/Job/sopStateDialog'
import EstimateValidationDialog from '@/components/Cargo/Job/estimateValidationDialog'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import CheckingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow'
import businessStatusLogDialog from '@/views/cargo/v0/Clearing/components/financeManage/businessStatusLogDialog'
import ediStatusLogDialog from '@/components/Cargo/Job/ediStatusLogDialog'
import { TabError } from '@/utils/class/TabError'
import { ensureExecuteSuccess, deepCopy, sleep, cleanCircleObject, catchErrorTip } from '@/utils/commonUtil'
import LocalStorageUtils from '@/utils/localStorageUtils'
import DateUtils from '@/utils/dateUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import StrUtils from '@/utils/StrUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { EntityDefaultValueUtil } from '@/class/cargo/model/utils/EntityDefaultValueUtil'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { ChargeUtils } from '@/class/cargo/model/utils/ChargeUtils'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { Company } from '@/class/model/mdm/Company'
import { saveRailwayExport, saveCopyJob, isContractExpiredForbidCreateJob, getRelatedJob, saveCloneJob } from '@/api/railwayExport/reBooking'
import { checkJobProvisionFlag, normalizeProvisionLock } from '@/api/provision/provisionData'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import FbaWarehousingDetail from '@/views/cargo/v0/FBA/Warehousing/fbaWarehousingDetail'
import FbaOutWarehouse from '@/views/cargo/v0/FBA/OverseaWarehousing/fbaOutWarehouse'
import TabWarehousingDetail from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabWarehousingDetail'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import cooperationBranchList from '@/components/Cargo/Job/cooperationBranchList'
import { updateState } from '@/api/booking/jobCooperate'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import checkingSaveJobWindow from '@/components/Cargo/Job/CheckingManager/CheckingSaveJobWindow'
import { queryCompany } from '@/api/company'
import { Office } from '@/class/model/sys/Office'
import { getUserDefaultDepartment } from '@/api/user'
import { getOfficeByUuid } from '@/api/office'
import { getObjectByCache, operateBranchIsOptional } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import CargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import TrustFromWindow from '@/views/cargo/v0/SeaExport/components/booking/tabs/trustFromWindow'
import { getImGroup } from '@/api/cargoIm'
import CargoIm from '@/components/Cargo/Common/CargoIm'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import JobApplyDialog from '@/components/Cargo/Common/Wrokflow/jobApplyDialog'
import { Job_CHARGE } from '@/class/cargo/model/parameters/WorkflowConstants'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import TabInsure from '@/components/Cargo/Job/booking/tabs/tabInsure'
import { LOG_RE_RAILWAY_BOOKING } from '@/class/cargo/model/parameters/SystemConstants'
import DataUpdateLogDialog from '@/components/Cargo/Job/dataUpdateLogDialog'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { fbaGetRelatedJob, fbaSaveCloneJob } from '@/api/Fba/fbaJob'
import BookingWorkspaceMixin from '@/mixin/BookingWorkspaceMixin'
import { cache, cacheName } from '@/utils/cacheManager'
import lodash from 'lodash'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import jobReturnReviewDialog from '@/components/Cargo/Job/jobReturnReviewDialog.vue'
import { getSopTemplateConfig } from '@/api/sysManage/baseConfig/businessManage'
import { createDetailTabComponent } from './destinationDetailTabMixin'

const ReDetailTabBookingFcl = createDetailTabComponent(tabBookingFcl, { isBookingNew() { return true } })
const ReDetailTabBookingFCLUICustom = createDetailTabComponent(tabBookingFCLUICustom, { isBookingNew() { return true } })
const ReDetailTabBookingMaster = createDetailTabComponent(tabBookingMaster, { isBookingNew() { return true } })
const ReDetailTabBookingMasterUICustom = createDetailTabComponent(tabBookingMasterUICustom, { isBookingNew() { return true } })

export default {
  name: 'ReDetailWorkspace',
  components: {
    jobReturnReviewDialog,
    TrustFromWindow,
    CargoUserSelect,
    TabWarehousingDetail,
    FbaOutWarehouse,
    FbaWarehousingDetail,
    cargoLeftRightResize, CargoButtonGroupSlider, tabBookingFcl: ReDetailTabBookingFcl, tabBookingFCLUICustom: ReDetailTabBookingFCLUICustom, tabBookingMaster: ReDetailTabBookingMaster, tabBookingMasterUICustom: ReDetailTabBookingMasterUICustom, tabWarehouse, tabTrucking, tabContainer, tabLclContainer,
    tabTradeDetail, tabCustomsInfo, tabTradeCommission, tabRailwayHeadwayTail, tabCharges, tabInternalBill, tabOverseaBill, tabAdvanceCharge, tabSopState,
    tabFileHistory, sopStateDialog, EstimateValidationDialog, cargoTemplateSelectorDialog, BatchCheckingWindow, CheckingWindow,
    businessStatusLogDialog, ediStatusLogDialog, cooperationBranchList, checkingSaveJobWindow, CargoIm, JobApplyDialog, TabInsure, DataUpdateLogDialog
  },
  mixins: [BookingWorkspaceMixin],
  props: {
    parentContext: { type: Object, required: true },
    isFba: { type: Boolean, required: false },
    view: { type: String, default: '' }
  },
  data() {
    return {
      imCacheKey: '',
      optName: '', // 操作名称
      context: new BookingWorkspaceContext(this.parentContext),
      pm: new BookingWorkspacePM(this),
      SystemConstants,
      isCommittedAllowAddCost: false,
      action: '',
      isSwitchingJob: false, // 是否正在切换job（尾程商务/海外跟单）
      editEventFlag: false, // 编辑事件标识
      isUppercaseByConfig: true, // CARGO-49117 是否大写
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressContextMenu: true,
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 160,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            innerRenderer: params => {
              return params.value
            }
          },
          tooltip: params => {
            return params.data.jobNo
          },
          suppressMenu: true
        },
        columnDefs: [],
        context: {
          componentParent: this
        },
        onRowClicked: async event => {
          this.action = event.data && Number(cache.config.get('JobDirectEditingStatus')) === 1 && event.data.jobState === 0 && !JobUtils.isBlockJob(event.data) && (await SecurityUtil.canEdit(new RailwayExportJob(event.data))) ? 'edit' : 'look'
          // 尾程商务/海外跟单详情页：参考海运订舱详情页的处理方式
          // 重新数据库中加载job，清空对象类型属性避免响应式更新导致的空白
          if (this.$route.path.startsWith('/DestinationBusiness')) {
            const data = event.data
            this.isGetNewJobInfoFromDb = true
            data.isCompleteRow = false
            data.version = 0
            for (const key in data) {
              if (typeof data[key] === 'object') {
                data[key] = ''
              }
            }
            // 更新当前页签标题为切换后的业务编号，避免新开页签
            this.$store.dispatch('tagsView/updateViewTitle', { view: this.$route, key: data.jobNo })
            await this.onRowClicked(event)
          } else {
            this.onRowClicked(event)
          }
        }
      },
      rowData: [],
      gridApi: null,
      JobUtils,
      currentRow: {},
      paramsOfTab: {},
      pendTabSet: new Set(),
      activeTabName: '',
      isRefresh: false,
      privilege: {
        btnEntrustment: null, // 委托按钮是否禁用
        consignationEnable: false, // 内部委托按钮是否可用
        button: {
          jobBookingPreSubmit: this.$checkPermission(['button_JobBooking_PreSubmit']),
          jobBookingSubmit: this.$checkPermission(['button_JobBooking_Submit']),
          jobBookingManagerSubmit: this.$checkPermission(['button_JobBooking_ManagerSubmit']),
          jobBookingManagerAuditSubmit: this.$checkPermission(['button_JobBooking_ManagerAuditSubmit']),
          jobBookingPrintProfit: this.$checkPermission(['button_JobBooking_PrintProfit']),
          jobBookingRetract: this.$checkPermission(['button_JobBooking_Retract']),
          reBookingCancelProfit: this.$checkPermission(['button_REBooking_cancelProfit']),
          button_REBooking_cancelShutout: this.$checkPermission(['button_REBooking_cancelShutout']),
          button_REBooking_Shutout: this.$checkPermission(['button_REBooking_Shutout'])
        },
        reBooking: {
          bookingTab: this.$checkPermission(['tab_REBooking_BookingTab']),
          warehouseTab: this.$checkPermission(['tab_REBooking_WarehouseTab']),
          reTruckingPage: this.$checkPermission(['tab_REBooking_RETruckingPage']),
          containersLayer: this.$checkPermission(['tab_REBooking_ContainersLayer']),
          lclManagerLayer: this.$checkPermission(['tab_REBooking_LclManagerLayer']),
          reCustomsInfo: this.$checkPermission(['tab_REBooking_RECustomsInfo']),
          headwayTail: this.$checkPermission(['tab_REBooking_headwayTail']),
          portalState: this.$checkPermission(['tab_REBooking_portalState'])
        },
        charge: {
          chargeView: this.$checkPermission(['tab_Charge_chargeView']),
          advanceCharge: this.$checkPermission(['tab_Charge_advanceCharge'])
        },
        chargeConfirm: {
          chargeConfirmView: this.$checkPermission(['tab_ChargeConfirm_chargeConfirmView'])
        },
        billTab: {
          billTabView: this.$checkPermission(['tab_billTab_billTabView'])
        },
        fileHistory: {
          fileHistoryView: this.$checkPermission(['tab_FileHistory_fileHistoryView'])
        }
      },
      btnInfo: {
        operateNameCode: -1,
        isPrint: true,
        isPrintOpr: false, // 是否打印操作（由于打印和提交中最后调用的有相同的方法，因此用改参数区分开来）
        isPrintCommit: false, // 打印利润分析表是否提交业务
        printEvent: null,
        isPreCommit: false, // 预提交
        allSubmitFcl: false, // 主票提交时是否提交全部拼票业务
        showMessage: true,
        btnEntrustment: this.$t('SeaExport.Consignation') // 内部委托按钮
      },
      stateInfo: {
        jobState: '',
        jobTitle: '',
        jobLock: '',
        provisionPublished: false, // 计提已发布状态
        provisionLock: { etdLocked: false, feeLocked: false }
      },
      tabInfo: {
        visible: {
          oujianCustomsInfo: false
        }
      },
      disabledPrint: false, // 打印按钮是否不可用
      sopTooltipOffset: 0,
      sopStateDialog: {
        visible: false,
        isNeedRefresh: false,
        defaultIsExpand: false,
        isNeedExpand: false
      },
      estimateValidationDialog: {
        visible: false,
        job: { estimateAccountsReceivable: 0, estimateAccountsPayable: 0, estimateGrossProfit: 0, situation: '' },
        estimateProfitRate: 0,
        tatolProfit: 0,
        callback: () => { }
      },
      shutOutDialog: {
        visible: false,
        shutOutTip1: '',
        shutOutTip2: '',
        shutOutButtonShow2: '',
        jobKeys: '',
        hasCharge: false
      },
      templateSelectorDialog: {
        visible: false,
        ctx: new RailwayExportJob(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      checkingWindow: {
        visible: false,
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      logCommand: this.$t('SeaExport.PortDataPushLog'),
      dataPushDialog: {
        visible: false,
        titles: [],
        dataMap: new Map()
      },
      businessStatusDialog: {
        visible: false
      },
      ediStatusLogDialog: {
        visible: false
      },
      saveJobNos: [], // 保存后的jobNo
      removedJobNos: [], // 被移除的jobNo
      btnGroupLook: null,
      btnGroupEdit: null,
      btnGroupNew: null,
      useOrderCenterMode: false, // 是否开启接单中心模式
      useOrderCenterBranch: false, // 是否开启接单分公司
      cooperationBranchListDialog: { // 协作分公司
        visible: false,
        jobUuid: '',
        job: null,
        orderCenterBranch: false
      },
      checkingSaveJobWindow: {
        visible: false,
        checkNode: 0,
        callBack: null,
        rowData: {}
      },
      sendBranchWindow: {
        visible: false,
        office: {},
        userId: 0,
        title: this.$t('SeaExport.SelectAction'),
        departmentId: 0,
        cmpIdx: 0,
        departmentOfficeId: 0,
        checkSalesMapping: false // 委托业务的销售映射到操作业务的揽货销售
      },
      trustFromWindow: {
        visible: false,
        trustJob: null // 关联业务job
      },
      jobApplyDialog: {
        visible: false
      },
      documentConfigId: Job_CHARGE.code,
      dataUpdateLogDialog: {
        visible: false,
        isNeedRefresh: false,
        job: {},
        defaultIsExpand: false,
        isNeedExpand: false
      },
      returnReviewDialog: {
        visible: false,
        selectedJobs: []
      },
      enableCommission: false,
      toExoSystemJYD: false,
      toExoSystemDLWL: false,
      toExoSystemZY: false,
      sendBranchSelectObjectOrigin: '0', // 发送分公司选项配置原始值
      processingPromiseList: [], // 正在处理中的异步操作对象列表
      sopTemplateConfigRE: {}, // SOP模板配置(铁路出口)
      sopTemplateConfigRI: {}, // SOP模板配置(铁路进口)
      templateName: ''
    }
  },
  computed: {
    user() {
      return this.context.user
    },
    job() {
      return this.currentRow
    },
    office() {
      return this.context.office
    },
    payableChargeLockedTooltip() {
      const details = []
      const person = ColumnUtils.getPayableChargeLockedPerson(this.job)
      const lockedAt = this.job.payableChargeLockedDate ? DateUtils.formatStandardDateTime(this.job.payableChargeLockedDate) : ''
      if (person) {
        details.push(`${this.$t('CargoMsg.Cargo_PayableFeeLockPerson')}：${person}`)
      }
      if (lockedAt) {
        details.push(`${this.$t('CargoMsg.Cargo_PayableFeeLockTime')}：${lockedAt}`)
      }
      return details.join('\n')
    },
    isNew() {
      return this.action === 'add' || this.action === 'split' || this.action === 'copy'
    },
    isEdit() {
      return this.action === 'edit'
    },
    masterFlag() {
      return this.paramsOfTab.masterFlag
    },
    isLclMaster() {
      return !!this.paramsOfTab.lclMasterUuid
    },
    printFclProfitVisible() {
      return !this.masterFlag && this.currentRow.jobState !== SystemConstants.SHUT_OUT && (
        this.currentRow.containerLoadType === ContainerLoadType.FCL_CARGO_TYPE.code ||
        this.currentRow.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code ||
        this.currentRow.containerLoadType === ContainerLoadType.BULK_CARGO_TYPE.code
      ) && (this.privilege.button.jobBookingSubmit || this.privilege.button.jobBookingPrintProfit)
    },
    printLclProfitVisible() {
      return this.currentRow.jobState !== SystemConstants.SHUT_OUT && (this.masterFlag ||
        this.currentRow.containerLoadType === ContainerLoadType.BC_CARGO_TYPE.code) &&
        (this.privilege.button.jobBookingSubmit || this.privilege.button.jobBookingPrintProfit)
    },
    printReturn() {
      return (this.privilege.button.jobBookingRetract || this.privilege.button.reBookingCancelProfit) &&
        this.currentRow.jobState === SystemConstants.COMMITED
    },
    preSubmitVisible() {
      return !this.printReturn && this.currentRow.jobState === SystemConstants.OPERATING &&
        this.privilege.button.jobBookingPreSubmit && this.currentRow.manageAuditStatus !== 1
    },
    submitVisible() {
      return !this.printReturn && (
        this.currentRow.jobState === SystemConstants.OPERATING ||
        this.currentRow.jobState === SystemConstants.COMMITED ||
        this.currentRow.jobState === SystemConstants.PRE_COMMIT
      ) && this.privilege.button.jobBookingSubmit && this.currentRow.manageAuditStatus !== 1
    },
    managerSubmitVisible() {
      return !this.printReturn && (
        this.currentRow.jobState === SystemConstants.OPERATING ||
        this.currentRow.jobState === SystemConstants.COMMITED ||
        this.currentRow.jobState === SystemConstants.PRE_COMMIT
      ) && this.privilege.button.jobBookingManagerSubmit
    },
    submitAuditVisible() {
      return !this.printReturn && (
        this.currentRow.jobState === SystemConstants.OPERATING ||
        this.currentRow.jobState === SystemConstants.PRE_COMMIT
      ) && this.privilege.button.jobBookingManagerAuditSubmit && this.currentRow.manageAuditStatus === 1
    },
    orderCenterBranch() { // 是否接单分公司
      return this.cooperateStatus === -1
    },
    cooperateBranchId() { // 协作分公司
      return this.$store.getters.currentOfficeId
    },
    cooperateStatus() {
      let cooperateStatus = this.paramsOfTab.cooperateStatus || -1
      if (this.paramsOfTab.cooperateCooperateStatus) {
        cooperateStatus = this.paramsOfTab.cooperateCooperateStatus
      }
      return cooperateStatus
    },
    cooperateBusinessTypeCode() {
      let cooperateBusinessTypeCode = this.paramsOfTab.cooperateBusinessTypeCode || ''
      if (!cooperateBusinessTypeCode && this.paramsOfTab.cooperateBusinessType) {
        cooperateBusinessTypeCode = this.paramsOfTab.cooperateBusinessType
      }
      return cooperateBusinessTypeCode
    },
    cooperateEditCustoms() { // 报关
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Customs')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditTrucking() { // 陆运
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Trucking')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditBooking() { // 订舱
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Booking')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditWarehouse() { // 仓储
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Warehouse')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditOther() { // 其他
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      if (this.orderCenterBranch) return true
      return false
    },
    isCooperate() { // 是否协作业务
      if (this.useOrderCenterMode && !this.orderCenterBranch && this.paramsOfTab.cooperateUuid) {
        return true
      }
      return false
    },
    isEditing() {
      return this.action !== 'look'
    },
    job() {
      return this.currentRow
    },
    location() {
      if (!this.isFba) {
        return LOG_RE_RAILWAY_BOOKING.code
      }
      return ''
    },
    hqDisabledOperate() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllDetail
    },
    canOperateJob() {
      if (this.hqViewAllDetail) {
        if (this.$store.getters.currentOfficeId === 1) {
          return false
        }
        if (this.currentRow &&
          this.currentRow.opOffice !== this.$store.getters.currentOfficeId &&
          this.currentRow.salesOffice !== this.$store.getters.currentOfficeId &&
          !this.mactchCooperateBranch(this.currentRow.cooperatebranch, this.$store.getters.currentOffice) &&
          !this.enableCommission
        ) {
          return false
        }
      }
      if (this.hierarchyViewDetail && this.currentRow) {
        return this.matchOwnerBranch(this.currentRow)
      }
      return true
    },
    showdCheckSalesMapping() {
      return this.toExoSystemJYD && Number(this.sendBranchSelectObjectOrigin) === 3 && !this.currentRow.fba
    },
    controlledLocked() {
      return this.toExoSystemDLWL && this.job.lob === 'RE' && this.job.exportControlledLocked
    },
    showReturnReview() { // 是否显示退回按钮
      return this.currentRow.jobState === SystemConstants.STATE_OPERATING.code && !this.currentRow.masterFlag &&
        !this.currentRow.lclMasterUuid && (this.currentRow.preverifyState === SystemConstants.VERIFYING_AUDITED.code ||
        this.currentRow.preverifyState === SystemConstants.VERIFYING_REVIEW_THROUGH.code)
    },
    canEditByPermission() {
      const menuType = this.$route.query.menuType
      const permissionCode = menuType === 'overseaTracking' ? 'button_OverseaTrackingEdit' : 'button_EndCommerceEdit'
      return this.$checkPermission([permissionCode])
    },
    sopTemplateConfig() {
      return this.job.lob === 'RE' ? this.sopTemplateConfigRE : this.sopTemplateConfigRI
    },
    trackingTemplateUuid() {
      return this.currentRow.trackingTemplateUuid
    }
  },
  watch: {
    action(newVal) {
      this.$nextTick(() => {
        this.$refs.cargoButtonGroupSlider.resizeHandler()
      })
    },
    editEventFlag(newVal) {
      if (newVal) {
        this.editEventFlag = false
        return catchErrorTip(() => {
          return this.editHandler()
        })
      }
    },
    '$store.getters.currentOfficeId': {
      async handler() {
        if (!(this.$route.path.startsWith('/DestinationBusiness') || this.$route.name === 'ReBooking') || this.view !== 'detail') {
          return
        }
        await cache.load(cacheName.CONFIG)
        this.enableCommission = cache.config.get('enableCommission') === '1'
        if (this.hqViewAllList && !this.hqViewAllDetail) {
          if (this.$store.getters.currentOfficeId === 1) {
            this.$confirm(this.$t('queryJob.SwitchHQNotView'), this.$t('BusinessIntelligence.businessIntelligenceChart.warmPrompt'), {
              confirmButtonText: this.$t('queryJob.JumpListPage'),
              showCancelButton: false,
              showClose: false,
              closeOnClickModal: false,
              type: 'warning'
            }).then(() => {
              this.goBack()
            }).catch(() => {})
          }
        }
      }
    },
    trackingTemplateUuid: {
      immediate: true,
      async handler(newVal) {
        this.templateName = await SopUtil.getTemplateName(newVal)
      }
    }
  },
  async created() {
    getSopTemplateConfig({ lob: 'RE' }).then(res => {
      this.sopTemplateConfigRE = res.data
    })
    getSopTemplateConfig({ lob: 'RI' }).then(res => {
      this.sopTemplateConfigRI = res.data
    })
    await this.context.prepareData()
    this.useOrderCenterMode = Number(this.context.config.get('useOrderCenterMode')) === 1
    this.useOrderCenterBranch = Number(this.context.config.get('orderCenterBranch')) === 1
    this.enableCommission = Number(this.context.config.get('enableCommission')) === 1
    this.isUppercaseByConfig = Number(this.context.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
  },
  mounted() {
    this.btnGroupLook = this.$el.getElementsByClassName('btn-group-look')[0]
    this.btnGroupEdit = this.$el.getElementsByClassName('btn-group-edit')[0]
    this.btnGroupNew = this.$el.getElementsByClassName('btn-group-new')[0]
  },
  updated() {
    if (!this.$refs['tabs']) {
      return
    }
    const panes = this.$refs['tabs'].panes
    const tabNameSet = new Set()
    for (const item of panes) {
      tabNameSet.add(item.name)
    }
    // 将失效的tab名称从pendTabSet中移除
    for (const item of [...this.pendTabSet]) {
      if (!tabNameSet.has(item)) {
        this.pendTabSet.delete(item)
      }
    }
  },
  methods: {
    // 页面状态切换（action改变）时调用
    async onShow(action, rowData, selectedRow) {
      this.imCacheKey = sessionStorage.getItem('imCacheKey')
      this.action = action
      this.$store.dispatch('app/setCanCloseModule', action === 'look')
      JobUtils.setCanCloseModuleMap(SystemConstants.CLOSE_MODULE_RE, action === 'look', selectedRow.jobNo || '')
      /* 先将原始数据赋给currentRow、paramsOfTab，让页面先展示 */
      this.currentRow = selectedRow
      this.paramsOfTab = this.currentRow
      this.$nextTick(() => {
        this.resetActiveTabName()
      })
      const loading = getLoading4Cxt(this)
      try {
        if (selectedRow.uuid) {
          this.rowData = rowData
        } else {
          if (!selectedRow.lclNumber && action !== 'copy' && action !== 'split') {
            await this.fillDefaultForRow(selectedRow)
          }
          if (action === 'copy') {
            if (selectedRow.seaEQ && selectedRow.seaEQ.length > 0) {
              // 装箱信息
              if (selectedRow.masterFlag) {
                ContainerUtil.autoAdjustMasterContainer(selectedRow)
              } else {
                ContainerUtil.autoJustContainerUsages(selectedRow)
              }
            }
          }
          // CARGO-53866 东丽 新增业务 销售默认带入当前登录人
          await JobUtils.loadingDlwlSales(selectedRow, this)
          this.setJobExtraInfo(selectedRow)
          this.rowData = [...rowData, selectedRow]
        }
        if (this.gridApi) {
          await sleep(100)
        } else {
          // 等待gridApi被赋值
          await ensureExecuteSuccess(() => this.gridApi)
        }
        this.setGridSelect(selectedRow)
      } catch (err) {
        loading.close()
        throw err
      }
      if (action === 'edit') { // 重新加载业务和费用
        selectedRow.version = 0
        selectedRow.charges = ''
        selectedRow.isCompleteRow = false
      }
      this.onRowClicked({ data: selectedRow })
      if (action === 'look') {
        const cfg = LocalStorageUtils.getConfiguration('RESopStatusPopupVisible')
        this.sopStateDialog.visible = !!cfg
        const logDialogVisible = LocalStorageUtilsNew.getConfiguration('REDataUpdateLogDialogVisible')
        this.dataUpdateLogDialog.visible = !!logDialogVisible
      }
    },
    // 切换页面状态
    againShow(action, row) {
      if (action) {
        this.action = action
      }
      if (this.isNew) {
        row = row || {}
      } else {
        row = row || this.currentRow
      }
      this.onShow(this.action, this.rowData, row)
    },
    resetActiveTabName() {
      if (this.isNew) {
        this.activeTabName = this.getDefaultActiveName()
      } else {
        const activePanes = this.$refs['tabs'].panes.filter(p => p.active)
        if (activePanes && activePanes.length === 0) {
          this.activeTabName = this.getDefaultActiveName()
        }
      }
    },
    getDefaultActiveName() {
      const firstPane = this.$refs['tabs'].panes[0]
      return firstPane ? firstPane.name : ''
    },
    // 为新增的row填充默认值
    async fillDefaultForRow(row) {
      const results = await Promise.all([
        this.pm.getDefaultJob(row.lob),
        this.pm.getOpDepartment(this.office.officeId)
      ])
      const defaultJob = results[0]
      const opDepartment = results[1]
      // 填充初始值
      new RailwayExportJob(row).fillDefaultValue()
      if (!row.hasOwnProperty('lob') || !row.lob) {
        row.lob = 'RE'
      }
      row.cargoType = 'GC'
      row.cargoSource = 'NC'
      row.opOffice = this.office.officeId
      if (opDepartment && Number(opDepartment.departmentId) > 0) {
        row.op = this.user.userId
        if (this.user.defaultDepId > 0 && this.user.defaultOfficeId === this.office.officeId) {
          row.opDepartment = this.user.defaultDepId
        } else {
          row.opDepartment = opDepartment.departmentId
        }
      }
      if (row.masterFlag) {
        row.cargoSource = ''
        row.containerLoadType = 'LCL'
      } else {
        row.containerLoadType = 'FCL'
      }
      row.tradeTerm = '110'
      row.taxNature = 0
      row.fba = this.isFba // 是否fba业务
      Object.assign(row, defaultJob)
      if (row.masterFlag) {
        row.dispatchingPlace = ''
      }
    },
    // 设置job的扩展信息
    setJobExtraInfo(job) {
      job.jobUuid = job.uuid
      job.parentUuid = job.lclMasterUuid
      if (job.lclMasterUuid) {
        job.path = job.lclMasterUuid + ',' + job.uuid
      } else {
        job.path = job.uuid
      }
      job.dataType = job.masterFlag ? 1 : 2 // 1 主票 2 小票
    },
    // 设置选中行
    setGridSelect(row) {
      const nodes = this.gridApi.rowModel.rowsToDisplay
      for (const item of nodes) {
        if (item.data.uuid === row.uuid || !item.data.uuid) {
          this.gridApi.setFocusedCell(item.rowIndex, this.gridApi.columnController.getAllDisplayedColumns()[0])
          break
        }
      }
    },
    // 行点击
    async onRowClicked(event) {
      const loading = getLoading4Cxt(this)
      try {
        await this.context.prepareData(true)
        if (this.action === 'look') {
          this.getImGroupFunc(event)
        }
        /* 加载配置 */
        this.isCommittedAllowAddCost = Number(this.context.config.get('IsCommittedAllowAddCost')) === 1
        this.btnInfo.allSubmitFcl = Number(this.context.config.get('AllSubmitFcl')) === 1
        this.btnInfo.isPrintCommit = Number(this.context.config.get('isPrintCommit')) === 1
        this.toExoSystemJYD = this.context.config.get('ToExoSystem') === 'JYD'
        this.toExoSystemDLWL = this.context.config.get('ToExoSystem') === 'DLWL'
        this.toExoSystemZY = this.context.config.get('ToExoSystem') === 'zy'
        this.sendBranchSelectObjectOrigin = this.context.config.get('SendBranchSelectObject')
        let data = event.data
        let loadCooperate = false
        // 加载完整信息
        if (!data.isCompleteRow) {
          const jobModel = new RailwayExportJob(data)
          if (jobModel.uuid) {
            await jobModel.loadJobRelated({
              job: !(jobModel.version >= 1), // 脏数据，需要重新载入（不要在此之前，填充默认值，因为version的默认值为1，会让表达式得不到正确的结果）
              seaEQ: true,
              lclSlaves: data.masterFlag,
              lclMaster: !data.masterFlag,
              charges: true,
              warehouseIn: true,
              warehouseInfo: true,
              trucking: true,
              containerUsages: true,
              containers: true,
              railwayContainers: true,
              cargoBulkDetail: !data.masterFlag,
              surchargeTerms: !data.masterFlag,
              fbaJob: data.fba, // fba业务就加载
              // railwayHeadwayTails: true 后续在页签内加载
              orderCenterMode: this.useOrderCenterMode,
              cooperateBranchId: this.cooperateBranchId
            })
            loadCooperate = true
            // 非主票，组装containers.containerUsage，和job.containerUsages里的元素指向同一个对象
            if (!jobModel.masterFlag) {
              ContainerUtil.buildContainerUsages(data)
            }
          } else {
            jobModel.seaEQ = jobModel.seaEQ || []
            jobModel.lclSlaves = jobModel.lclSlaves || []
            jobModel.lclMaster = jobModel.lclMaster || null
            jobModel.charges = jobModel.charges || []
            jobModel.warehouseIn = jobModel.warehouseIn || []
            jobModel.warehouseInfo = jobModel.warehouseInfo || []
            jobModel.trucking = jobModel.trucking || []
            jobModel.containerUsages = jobModel.containerUsages || []
            jobModel.containers = jobModel.containers || []
            jobModel.cargoBulkDetail = jobModel.cargoBulkDetail || []
            jobModel.surchargeTerms = jobModel.surchargeTerms || []
            jobModel.railwayHeadwayTails = jobModel.railwayHeadwayTails || []
          }
          jobModel.fillDefaultValue() // 填充其他默认值
          data.isCompleteRow = true
          if (data.warehouseInfo && data.warehouseInfo.length > 0) {
            data.warehouseName = data.warehouseInfo[0].warehouseName
          }
          // 需重新构造对象，以便新增加的属性可以被vue监听到
          const newData = { ...data }
          /* 替换旧数据 */
          const index = this.rowData.findIndex(p => p === data)
          const node = this.gridApi.rowModel.rowsToDisplay.find(p => p.data === data)
          if (index >= 0 && node) {
            this.rowData[index] = newData
            node.data = newData
          }
          data = newData
        }
        // 协作分公司信息
        if (this.useOrderCenterMode) {
          if (loadCooperate && data.cooperate && data.cooperate.uuid) {
            console.log('data.cooperate===', data.cooperate)
            // 记录原值
            data.opOffice_original = data.opOffice // 分公司
            data.op_original = data.op // 操作
            data.csr_original = data.csr // 客服
            data.overseaOp_original = data.overseaOp // 海外操作
            data.dc_original = data.dc // 单证
            data.planner_original = data.planner // 航线负责人
            data.opDepartment_original = data.opDepartment // 操作部门
            //
            data.opOffice = data.cooperate.branchId // 分公司
            data.op = data.cooperate.opId // 操作
            data.csr = data.cooperate.csrId // 客服
            data.overseaOp = data.cooperate.overseaOp // 海外操作
            data.dc = data.cooperate.dcId // 单证
            data.planner = data.cooperate.planner // 航线负责人
            data.opDepartment = data.cooperate.opDepartment // 操作部门
            JobUtils.convertJobFromCooperateInfo(data, data.cooperate)
            //
            data.cooperateUuid = data.cooperate.uuid
            data.cooperateCooperateStatus = data.cooperate.cooperateStatus
            data.cooperateBusinessType = data.cooperate.businessType
          }
        }
        if (this.toExoSystemZY) {
          // 中文品名
          data.cargoChineseName_original = data.cargoChineseName
          // 英文品名
          data.cargoEnglishName_original = data.cargoEnglishName
        }
        this.currentRow = data
        // CARGO-34157 编辑费用后，提示：仓库信息发生变更
        if (!this.currentRow.warehouseCmp) {
          this.currentRow.warehouseCmp = 0
        }
        this.currentRow.warehouseRecord = this.currentRow.warehouseCmp || 0
        // 检查主票下的小票，如果主票有修改，同步将小票放在修改列表中
        if (this.currentRow.lclSlaves && this.currentRow.lclSlaves.length > 0) {
          const index = this.saveJobNos.findIndex(p => p.uuid === this.currentRow.uuid)
          if (index >= 0) {
            for (const slave of this.currentRow.lclSlaves) {
              const row = this.rowData.find(p => p.uuid === slave.uuid)
              if (row) {
                for (const key in slave) {
                  if (typeof row[key] === 'object' || key === 'version') {
                    continue
                  }
                  row[key] = slave[key]
                }
                this.saveJobNos.push(row)
              }
            }
          }
        }
      } finally {
        loading.close()
      }
      this.resetParamsOfTab()
      this.pendTabSet.clear()
      this.context.modifiedData = {}
      this.context.removedData = {}
      this.processingPromiseList = []
      this.showJobState()
      this.showJobTitle()
      this.checkProvisionPublishedStatus()
      this.updateControlsState()
      if (!event.skipTabHandle) {
        this.$nextTick(() => {
          this.resetActiveTabName()
          this.handleTabClick()
        })
      }
    },
    resetParamsOfTab() {
      if (this.action === 'edit') {
        this.paramsOfTab = deepCopy(this.currentRow)
      } else {
        this.paramsOfTab = this.currentRow
      }
    },
    // 业务状态显示
    showJobState() {
      if (!this.currentRow.uuid) {
        this.stateInfo.jobState = ''
        this.stateInfo.jobLock = ''
        this.stateInfo.jobChangeState = ''
        return
      }
      this.stateInfo.jobState = ColumnUtils.getJobState(this.currentRow)
      this.stateInfo.jobLock = JobUtils.isBlockJob(this.currentRow) ? this.$t('Message.Locked') : ''
      // 改单状态
      if (Number(this.context.config.get('IsCommittedAllowAddCost')) === 1) {
        this.stateInfo.jobChangeState = ColumnUtils.getJobChangeState2(this.currentRow)
      }
    },
    formatJobTitleMblSegment(job) {
      if (!job) return '-'
      const m = job.mbl != null && String(job.mbl).trim() !== '' ? job.mbl : job.MBL_NO != null ? job.MBL_NO : ''
      const v = String(m).trim()
      return v || '-'
    },
    async showJobTitle() {
      const job = this.currentRow
      let jobTitle = (Number(this.context.config.get('DetailTitleShowModel')) || 0) === 0 ? job.jobNo : StrUtils.toHalfwordUpperCase(job.mbl)
      if (job.customerId) {
        const cmp = this.context.companyList.find(p => p.cmpIdx === job.customerId)
        if (cmp) {
          const creditTerm = await JobUtils.getSettlementTypeByJobInformation(job, 'customerId')
          const billingType = await Company.loadCustomer(cmp.uuid).then(data => {
            if (data) {
              const str1 = ` ${this.$t('Message.BillingType')}[${this.$t('Message.ByTicket')}]`
              const str2 = `${this.$t('Message.BillingType')}[${this.$t('Message.Monthly')}]`
              return data.invoiceMode === 0 ? str1 : str2
            }
            return ''
          })
          const detailModel = Number(this.context.config.get('DetailTitleShowModel')) || 0
          const mblMid = detailModel === 0 ? this.formatJobTitleMblSegment(job) : null
          if (detailModel === 0) {
            jobTitle =
              '<span style="margin-right:10px">' +
              jobTitle +
              '</span><span style="margin-right:10px">' +
              mblMid +
              '</span><span style="margin-right:10px">' +
              cmp.chineseName +
              creditTerm +
              '</span><span>' +
              billingType +
              '</span>'
          } else {
            jobTitle = '<span style="margin-right:10px">' + jobTitle + '</span><span style="margin-right:10px">' + cmp.chineseName + creditTerm + '</span><span>' + billingType + '</span>'
          }
        }
      }
      this.stateInfo.jobTitle = jobTitle
    },
    // 检查计提发布状态
    async checkProvisionPublishedStatus() {
      if (!this.job || !this.job.uuid) {
        this.stateInfo.provisionLock = { etdLocked: false, feeLocked: false }
        return
      }

      try {
        const res = await checkJobProvisionFlag(this.job.uuid)
        this.stateInfo.provisionLock = res.ok ? normalizeProvisionLock(res.data) : { etdLocked: false, feeLocked: false }
      } catch (error) {
        console.error('检查计提发布状态失败:', error)
        this.stateInfo.provisionLock = { etdLocked: false, feeLocked: false }
      }
    },
    // 重置行数据
    reset(rows) {
      for (const row of rows) {
        // 标识为脏数据
        row.version = 0
        // 重置子表数据
        for (const key in row) {
          if (typeof row[key] === 'object') {
            row[key] = ''
          }
        }
        row.isCompleteRow = false
      }
    },
    // 查看
    lookHandler() {
      this.againShow('look')
    },
    // 新增
    async addHandler(row) {
      this.$emit('add', row || {})
    },
    // 编辑
    async editHandler() {
      if (this.currentRow.jobState !== 0) {
        this.$message.warning(this.$t('Message.ThisJobIsNotWorkingCanNotBeEdited'))
        return
      }
      if (!await SecurityUtil.canEdit(new RailwayExportJob(this.currentRow))) {
        this.$message.warning(this.$t('Message.NoPermissionToEditTheJob'))
        return
      }
      this.$refs.cargoLeftRightResize.hideLeft()
      this.btnGroupLook.style.display = 'none'
      this.btnGroupEdit.style.display = ''
      this.$refs.cargoButtonGroupSlider.resizeHandler()
      // 延迟执行，避免阻塞页面渲染
      setTimeout(() => {
        this.againShow('edit')
      }, 5)
    },
    splitHandle(row) {
      this.view = 'detail'
      this.onShow('split', this.rowData, row)
    },
    // 复制
    toCopy() {
      if (this.currentRow.customerId) {
        const loading = getLoading4Cxt(this)
        isContractExpiredForbidCreateJob(this.currentRow.customerId).then(res => {
          loading.close()
          if (res.data) {
            this.$message.warning('该委托单位合同到期，不能再创建业务')
          } else {
            this.$emit('copy', this.currentRow)
          }
        }).catch(() => {
          loading.close()
        })
      }
    },
    // sop双击事件
    onBtnListDoubleClicked() {
      LocalStorageUtils.setConfiguration('RESopStatusPopupVisible', true)
      this.sopStateDialog.visible = true
      this.sopStateDialog.defaultIsExpand = true
      this.sopStateDialog.isNeedExpand = true
    },
    resetSopTooltip(event) {
      this.sopTooltipOffset = event.offsetX
    },
    // sop关闭处理
    sopStateDialogClose() {
      this.sopStateDialog.defaultIsExpand = true
      LocalStorageUtils.setConfiguration('RESopStatusPopupVisible', false)
    },
    // log 关闭处理
    dataUpdateLogDialogClose() {
      this.dataUpdateLogDialog.defaultIsExpand = true
      LocalStorageUtilsNew.setConfiguration('REDataUpdateLogDialogVisible', false)
    },
    beforeLeaveTab(activeName, oldActiveName) {
      if (oldActiveName) {
        this.endTabHandler(oldActiveName)
      }
      return true
    },
    // tab页签切换
    handleTabClick() {
      // 不可打印的页签
      const notPrintTabs = ['tabTradeDetail', 'tabTradeCommission', 'tabAdvanceCharge', 'tabSopState', 'tabFileHistory']
      this.disabledPrint = notPrintTabs.includes(this.activeTabName)
      this.$nextTick(() => {
        const oldSize = this.pendTabSet.size
        this.pendTabSet.add(this.activeTabName)
        const isRefresh = this.pendTabSet.size > oldSize
        this.$refs[this.activeTabName].onShow(this.paramsOfTab, isRefresh)
      })
    },
    // tab页签结束后的处理（在编辑状态下）
    async endTabHandler(tabName) {
      if (this.action === 'look') {
        return
      }
      const tab = this.$refs[tabName]
      if (!tab) {
        return
      }
      if (tab.endTabHandler && typeof tab.endTabHandler === 'function') {
        const result = tab.endTabHandler()
        if (result instanceof Promise) {
          await result
        }
      }
    },
    // 重置tab页签
    resetTab(tabName) {
      this.pendTabSet.delete(tabName)
    },
    // 同步数据
    syncData(data) {
      Object.assign(this.currentRow, data)
    },
    addBatchLcl(lclJob) {
      this.againShow('add', lclJob)
    },
    transferTargetRow(jobUuid) {
      const selectedRow = this.rowData.find(p => p.uuid === jobUuid)
      if (selectedRow) {
        this.againShow('edit', selectedRow)
      }
    },
    // 加入小票
    addSlavedJob(jobs) {
      const jobKeys = []
      for (const job of jobs) {
        this.setJobExtraInfo(job)
        jobKeys.push(job.uuid)
      }
      const rows = this.rowData.filter(p => !jobKeys.includes(p.uuid)) // 过滤掉旧数据
      this.rowData = [...rows, ...jobs]
      this.saveJobNos.push(this.currentRow)
      this.saveJobNos.push(...jobs)
      for (let i = this.removedJobNos.length - 1; i >= 0; --i) {
        if (jobs.findIndex(p => p.uuid === this.removedJobNos[i].uuid) >= 0) {
          this.removedJobNos.splice(i, 1)
        }
      }
      this.$nextTick(() => {
        this.setGridSelect(this.currentRow)
      })
      this.isRefresh = true
    },
    // 移除小票
    removeJobFromMaster(jobKeys) {
      const rows = this.rowData.filter(p => !jobKeys.includes(p.uuid))
      const removedRows = this.rowData.filter(p => jobKeys.includes(p.uuid))
      this.rowData = rows
      this.saveJobNos.push(this.currentRow)
      this.removedJobNos.push(...removedRows)
      this.$nextTick(() => {
        this.setGridSelect(this.currentRow)
      })
      this.isRefresh = true
    },
    removeJob(jobUuid) {
      const index = this.rowData.findIndex(p => p.uuid === jobUuid)
      if (index >= 0) {
        this.rowData.splice(index, 1)
        this.removedJobNos.push(this.rowData[index])
        this.$nextTick(() => {
          this.setGridSelect(this.currentRow)
        })
        this.isRefresh = true
      }
      this.saveJobNos.push(this.currentRow)
    },
    // 保存业务相关数据
    async save() {
      const loading = getLoading('app-main-content')
      try {
        if (this.processingPromiseList.length > 0) {
          const processingPromiseList = [...this.processingPromiseList]
          for (const processingPromise of processingPromiseList) {
            try {
              await processingPromise
            } catch (err) {
              console.log(err)
            }
          }
        }
        // 当前页签结束后的处理
        if (this.activeTabName) {
          await this.endTabHandler(this.activeTabName)
        }
        const body = { action: this.action }
        // 合并各页签的提交数据
        try {
          for (const item of this.pendTabSet) {
            const getSubmitData = this.$refs[item].getSubmitData
            if (getSubmitData && typeof getSubmitData === 'function') {
              let tabData = null
              const result = this.$refs[item].getSubmitData()
              if (result instanceof Promise) {
                tabData = await result
              } else {
                tabData = result
              }
              this.mergeObjectWithUuid(body, tabData)
            }
          }
          this.doNotClickTabData(body)
          // 被联动修改了的数据
          this.mergeObjectWithUuid(body, this.context.modifiedData)
          // 待删除的数据
          this.mergeObjectWithUuid(body, this.context.removedData)
          // 清空job子表数据
          if (body.job) {
            // 拷贝一个副本，避免在保存成功前，影响原始数据
            if (body.job === this.paramsOfTab) {
              body.job = deepCopy(body.job)
            }
            for (const key in body.job) {
              if (typeof body.job[key] === 'object') {
                delete body.job[key]
              }
            }
          }
          cleanCircleObject(body)
          // 还原接单分公司
          if (this.useOrderCenterMode) {
            if (body.job && body.job.cooperateUuid) {
              body.job = { ...body.job }
              body.job.opOffice = body.job.opOffice_original || body.job.opOffice // 分公司
              body.job.op = body.job.op_original || body.job.op // 操作
              body.job.csr = body.job.csr_original || body.job.csr // 客服
              body.job.overseaOp = body.job.overseaOp_original || body.job.overseaOp // 海外操作
              body.job.dc = body.job.dc_original || body.job.dc // 单证
              body.job.planner = body.job.planner_original || body.job.planner // 航线负责人
              body.job.opDepartment = body.job.opDepartment_original || body.job.opDepartment // 操作部门
              JobUtils.restoreJobFromCooperateInfo(body.job)
            }
          }
          if (body.containerUsages) {
            for (const item of body.containerUsages) {
              if (item.container && item.container.containerUsage === '') { // 避免后台fastjson解析报错
                item.container.containerUsage = null
              }
            }
          }
          JobUtils.handleChargeForSave(body)
        } catch (err) {
          if (err instanceof TabError) {
            this.activeTabName = err.tabName
            if (err.message) {
              this.$message.warning({ dangerouslyUseHTMLString: true, message: err.message })
            }
            return
          } else {
            throw err
          }
        }
        // 复制时校验费用名称是否被禁用
        if (this.action === 'copy') {
          const flag = await JobUtils.checkChargeItemDisabled(this, body.charges)
          if (!flag) {
            return
          }
        }
        // CARGO-54098 个性需求评估 增加SOP特殊限制
        if (body.job && body.job.lob === 'RE' && this.toExoSystemDLWL && !await JobUtils.checkExportControlledProduct(body.job, this)) {
          return
        }

        // CARGO-53261 14615中邮，敏感词管理校验需要双重提醒
        if (body.job && body.job.lob === 'RE' && this.toExoSystemZY && !await JobUtils.checkZySensitiveWord(body.job, this)) {
          return
        }

        // 若为自揽货 清空指定货代理取值
        if (body.job && body.job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
          body.job.designationAgent = 0
        }

        // 后端触发SOP使用
        if (!this.isNew) {
          body.jobUuid = this.currentRow.uuid
        }

        // 获取业务对应的sop模板，若不一致，则提醒是否更换，若一致不处理，若新增，则
        await SopUtil.checkSopTemplate(body.job, this, null, null, this.sopTemplateConfig)

        // 在保存前进行校验
        const bodyJob = body.job
        if (!(await this.pm.checkBeforeSave(bodyJob))) {
          return
        }
        const useCheckRule = Number(this.context.config.get('useCheckRule')) === 1
        if (useCheckRule && body && body.hasOwnProperty('job') && body.job) {
          const hasCheckRuleForSaveJob = await JobUtils.hasCheckRuleCondition(useCheckRule, CheckRuleConstants.NODE_SAVE_BUSINESS.code, this.$store.getters.currentOfficeId)
          if (hasCheckRuleForSaveJob) {
            const result = await JobUtils.checkBySaveJobNode({ ...body, charges: this.paramsOfTab.charges }, this.currentRow.lob, CheckRuleConstants.NODE_SAVE_BUSINESS.code)
            if (result.needShowDialog) {
              loading.close()
              const callBack = async() => { await this.continueSaving(body, loading, true) }
              this.checkingSaveJobWindow.checkNode = CheckRuleConstants.NODE_SAVE_BUSINESS.code
              this.checkingSaveJobWindow.rowData = result.rowData
              this.checkingSaveJobWindow.callBack = callBack
              this.checkingSaveJobWindow.visible = true
            } else {
              await this.continueSaving(body, loading, false)
            }
          } else {
            await this.continueSaving(body, loading, false)
          }
        } else {
          await this.continueSaving(body, loading, false)
        }
      } finally {
        loading.close()
      }
    },
    async continueSaving(body, loading, closingLoading = false) {
      try {
        if (closingLoading) {
          loading = getLoading4Cxt(this)
        }
        // 保存到数据库
        const oldBusinessDate = this.currentRow.lob === 'RE' ? this.currentRow.etd : this.currentRow.eta
        const businessDate = this.paramsOfTab.lob === 'RE' ? this.paramsOfTab.etd : this.paramsOfTab.eta
        const charges = this.paramsOfTab.charges
        body.location = this.location
        body.receiptCharges = this.context.receiptCharges
        let blockCreditData = null
        await this.saveRailwayExportFunc(body).then(res => {
          const result = res.data.job
          if (result) {
            Object.assign(this.currentRow, result)
            /* 重置多余字段 */
            delete this.currentRow.salsalesRecord
            delete this.currentRow.warehouseRecord
            this.setJobExtraInfo(this.currentRow)
            this.saveJobNos.push(this.currentRow)
            this.isRefresh = true
          }
          /* 重置受影响的行数据 */
          let dirtyRows = null
          if (this.currentRow.masterFlag) {
            dirtyRows = this.rowData.filter(p => p.lclMasterUuid === this.currentRow.uuid)
          } else if (this.currentRow.lclMasterUuid) {
            dirtyRows = this.rowData.filter(p => p.uuid === this.currentRow.lclMasterUuid)
          }
          this.reset(dirtyRows ? [...dirtyRows, this.currentRow] : [this.currentRow])
          // 先将拆分主票对应的小票记录，保存后使用
          const lclSlaves = body.lclSlaves
          if (this.action === 'split' && lclSlaves && lclSlaves.length > 0) {
            if (!this.currentRow.beSplitedLclUuids) {
              this.currentRow.beSplitedLclUuids = Array.from(lclSlaves, p => p.uuid)
            }
            // 原被拆分的主票uuid集合
            const oldMasterUuidSet = new Set()
            /* 更新小票 */
            const rows = this.rowData.filter(p => this.currentRow.beSplitedLclUuids.includes(p.uuid))
            for (const lcl of rows) {
              oldMasterUuidSet.add(lcl.lclMasterUuid)
              lcl.lclMasterUuid = this.currentRow.uuid
              lcl.parentUuid = this.currentRow.uuid
              lcl.path = this.currentRow.uuid + ',' + lcl.uuid
              lcl.version = 0 // 标识为脏数据
              lcl.isCompleteRow = false
            }
            /* 原被拆分的主票，需重新加载 */
            const oldMasterJobs = this.rowData.filter(p => oldMasterUuidSet.has(p.uuid))
            this.reset(oldMasterJobs)
          }
          if (this.isNew) {
            this.gridApi.setRowData(this.rowData)
          }
          blockCreditData = res.data.blockCreditData
        })
        // 主票页签新增多个小票，保存的处理逻辑
        if (this.currentRow.lclNumber && this.currentRow.uuid) {
          const job = this.currentRow
          if (job.lclNumber > 1) {
            await this.saveLclJob(job.uuid, job.lclNumber - 1)
          }
          delete job.lclNumber
          // 切换回主票
          this.currentRow = this.rowData.find(p => p.uuid === job.lclMasterUuid)
          this.currentRow.version = 0
        }
        // 复制
        if (this.currentRow.copyNum && this.currentRow.uuid) {
          const copyNum = Number(this.currentRow.copyNum)
          if (copyNum > 1) {
            await this.saveCopyJobHandle(this.currentRow.uuid, copyNum - 1)
          }
          delete this.currentRow.copyNum
        }
        // 保存成功后执行各业签的回调方法
        for (const item of this.pendTabSet) {
          const executeTask = this.$refs[item].executeTask
          if (executeTask && typeof executeTask === 'function') {
            const result = this.$refs[item].executeTask()
            if (result instanceof Promise) {
              await result
            }
          }
        }
        if (JobUtils.isBlockJob(this.currentRow)) {
          // 保存成功之后如果是信控锁住则会弹此提示【Job.as中的save方法】
          setTimeout(() => {
            this.$message.warning(this.$t('SeaExport.CheckCreditSaveTip'))
          }, 2000)
        }
        // 保存业务触发SOP后需要刷新 SOP操作状态弹框
        if (this.sopStateDialog.visible) {
          setTimeout(() => {
            this.sopStateDialog.isNeedRefresh = true
          }, 3000)
        }
        // 保存业务后需要刷新 变更日志记录弹框
        if (this.dataUpdateLogDialog.visible) {
          setTimeout(() => {
            this.dataUpdateLogDialog.isNeedRefresh = true
          }, 3000)
        }
        this.againShow('look')
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        /*        if (this.currentRow.jobState === 0 && businessDate !== oldBusinessDate && ChargeUtils.exchangeRateNeedUpdate(charges, businessDate)) {
          setTimeout(() => {
            this.$message.success(this.$t('queryJob.BusinessDateChangedUpdateExchangeRate'))
          }, 100)
        }*/
        JobUtils.handleCreditRemind(this.currentRow, blockCreditData)
      } catch (err) {
        throw err
      } finally {
        if (closingLoading) {
          loading.close()
        }
      }
    },
    async saveRailwayExportFunc(body) {
      // 数据已被其他人修改
      let dataModified = false
      let userName = ''
      let modifyDate = ''
      let err = null
      try {
        return await saveRailwayExport(body, true, true)
      } catch (res) {
        let error17 = null
        if (res.errors) {
          error17 = res.errors.find(p => p.code === '0017')
        }
        if (error17) {
          dataModified = true
          const start = error17.message.indexOf('[')
          if (start > -1) {
            const end = error17.message.indexOf(']', start)
            if (end > -1) {
              userName = error17.message.substring(start + 1, end)
            }
          }
          const match = error17.message.match(/[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}/)
          modifyDate = match[0] || ''
          err = res
        } else {
          this.$message({
            showClose: true,
            message: res.errorMsg,
            dangerouslyUseHTMLString: res.errorMsg && res.errorMsg.indexOf('<br/>') > -1,
            type: 'error',
            duration: 5 * 1000
          })
          throw res
        }
      }
      if (dataModified) {
        const oldData = lodash.cloneDeep(this.currentRow) // 旧版本的数据
        const editOldData = lodash.cloneDeep(this.paramsOfTab) // 正在编辑的旧版本的数据
        const pendTabs = [...this.pendTabSet]
        const modifiedData = { ...this.context.modifiedData }
        this.currentRow.version = 0
        for (const key in this.currentRow) {
          if (typeof this.currentRow[key] === 'object') {
            this.currentRow[key] = ''
          }
        }
        this.currentRow.isCompleteRow = false
        await this.onRowClicked({ data: this.currentRow, skipTabHandle: true })
        if (pendTabs.includes('tabTradeDetail')) {
          await new RailwayExportJob(this.currentRow).getPoItems()
        }
        if (pendTabs.includes('tabTradeCommission')) {
          await new RailwayExportJob(this.currentRow).getPoList()
        }
        const newData = this.currentRow // 最新版本的数据
        this.paramsOfTab = JobUtils.compareAndMergeJobData(oldData, editOldData, newData)
        this.pendTabSet.clear()
        for (const pendTab of pendTabs) {
          this.pendTabSet.add(pendTab)
          this.$refs[pendTab].onShow(this.paramsOfTab, true)
        }
        const filedMap = new Map([['truckingInfo', 'trucking']])
        for (const key in modifiedData) {
          const sourceKey = filedMap.get(key) || key
          if (modifiedData[key] instanceof Array && this.paramsOfTab[sourceKey] instanceof Array) {
            const targetArray = modifiedData[key]
            const souceArray = this.paramsOfTab[sourceKey]
            for (let i = 0; i < targetArray.length; ++i) {
              const sourceItem = souceArray.find(p => p === targetArray[i] || (p.uuid && p.uuid === targetArray[i].uuid))
              if (sourceItem) {
                targetArray[i] = sourceItem
              }
            }
            this.context.modifiedData[key] = modifiedData[key]
          }
        }
        const flag = await this.$confirm(this.$t('queryJob.DataModifiedHasMergeContinueSave', [userName, modifyDate]), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('Message.Yes'),
          cancelButtonText: this.$t('Message.No'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (flag) {
          const newBody = {}
          if (body.job) {
            newBody.job = { ...this.paramsOfTab }
            // 还原接单分公司
            if (this.useOrderCenterMode) {
              if (newBody.job.cooperate && newBody.job.cooperate.uuid) {
                newBody.job.opOffice = newBody.job.opOffice_original || newBody.job.opOffice // 分公司
                newBody.job.op = newBody.job.op_original || newBody.job.op // 操作
                newBody.job.csr = newBody.job.csr_original || newBody.job.csr // 客服
                newBody.job.overseaOp = newBody.job.overseaOp_original || newBody.job.overseaOp // 海外操作
                newBody.job.dc = newBody.job.dc_original || newBody.job.dc // 单证
                newBody.job.planner = newBody.job.planner_original || newBody.job.planner // 航线负责人
                newBody.job.opDepartment = newBody.job.opDepartment_original || newBody.job.opDepartment // 操作部门
                JobUtils.restoreJobFromCooperateInfo(newBody.job)
              }
            }
            for (const key in newBody.job) {
              if (newBody.job[key] instanceof Object) {
                newBody.job[key] = ''
              }
            }
          }
          for (const key in body) {
            if (key === 'job') {
              continue
            }
            const sourceKey = filedMap.get(key) || key
            if (body[key] instanceof Array) {
              if (this.paramsOfTab[sourceKey] instanceof Array) {
                const uuids = []
                newBody[key] = []
                for (const bodyItem of body[key]) {
                  if (bodyItem.uuid) {
                    uuids.push(bodyItem.uuid)
                  } else {
                    newBody[key].push(bodyItem)
                  }
                }
                for (const mergeItem of this.paramsOfTab[sourceKey]) {
                  if (uuids.includes(mergeItem.uuid)) {
                    newBody[key].push(mergeItem)
                  }
                }
              } else {
                newBody[key] = body[key]
              }
            } else if (body[key] instanceof Object) {
              newBody[key] = this.paramsOfTab[sourceKey] || body[key]
            } else {
              newBody[key] = body[key]
            }
          }
          cleanCircleObject(newBody)
          return await saveRailwayExport(newBody, true)
        } else {
          throw err
        }
      }
    },
    // 复制、拆分主票保存前处理【未点击页签的数据也需要保存】
    doNotClickTabData(body) {
      const isCopy = this.action === 'copy'
      const job = this.currentRow
      if (!body || !job || !isCopy) return
      // 复制独有
      if (isCopy) {
        if (job.charges && job.charges.length > 0) {
          if (Object.prototype.hasOwnProperty.call(body, 'charges')) {
            for (const item of job.charges) {
              const index = body.charges.findIndex(p => p === item || (p.receivable === item.receivable && p.serialNumber && p.serialNumber === item.serialNumber))
              if (index < 0) {
                body.charges.push(item)
              }
            }
          } else {
            Object.assign(body, { charges: job.charges })
          }
        }
      }
    },
    // 合并对象属性，通过比较uuid判断对象是否相等
    mergeObjectWithUuid(target, source) {
      for (const key in source) {
        const srcValue = source[key]
        const targetValue = target[key]
        if ((srcValue instanceof Array) && (targetValue instanceof Array)) {
          for (const item of srcValue) {
            const index = targetValue.findIndex(p => p === item || (p.uuid && p.uuid === item.uuid))
            if (index < 0) {
              targetValue.push(item)
            }
          }
        } else {
          target[key] = srcValue
        }
      }
    },
    // 保存剩下的新增小票业务【后台复制并保存】
    async saveLclJob(jobUuid, copyNum) {
      const item = {
        jobUuid,
        masterJobNo: this.currentRow.masterJobNo || '',
        branchId: this.office.officeId,
        copyNum,
        all: true,
        copyOnly: false, // 是否是复制业务，新增业务日志时使用
        location: this.location
      }
      await saveCopyJob(item).then(res => {
        const newJobList = res.data
        if (newJobList && newJobList.length > 0) {
          for (const copyJob of newJobList) {
            this.setJobExtraInfo(copyJob)
            this.saveJobNos.push(copyJob)
          }
          this.rowData = [...this.rowData, ...newJobList]
        }
        JobUtils.copyFailTip(copyNum, newJobList, this)
      })
    },
    // 保存剩下的复制业务【后台复制并保存】
    async saveCopyJobHandle(jobUuid, copyNum) {
      const item = {}
      item.jobUuid = jobUuid
      item.branchId = this.$store.getters.currentOfficeId
      // 复制哪些页签的数据
      const lob = this.currentRow.lob
      item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob)
      item.copyNum = copyNum
      item.all = true
      item.copyOnly = true // 是否是复制业务，新增业务日志时使用
      item.location = this.location
      await saveCopyJob(item).then(res => {
        const newJobList = res.data
        if (newJobList && newJobList.length > 0) {
          for (const copyJob of newJobList) {
            this.setJobExtraInfo(copyJob)
            this.saveJobNos.push(copyJob)
          }
          this.rowData = [...this.rowData, ...newJobList]
        }
        JobUtils.copyFailTip(copyNum, newJobList, this)
      })
    },
    saveDefaultVal() {
      const loading = getLoading4Cxt(this)
      EntityDefaultValueUtil.getInstance().saveEntityDefaultValue(['Job', 'RailwayExportJob'], this.paramsOfTab).then(() => {
        this.$message.success(this.$t('Message.DefaultValuesAreSavedSuccessfully'))
      }).finally(() => {
        loading.close()
      })
    },
    // 取消编辑
    cancelEdit(done) {
      this.$confirm(this.$t('CargoMsg.Cargo_CCOCM'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        JobUtils.setCanCloseModuleMap(SystemConstants.CLOSE_MODULE_RE, true, this.currentRow ? this.currentRow.jobNo || '' : '')
        if (typeof done === 'function') {
          done()
        }
      }).catch()
    },
    goBack() {
      this.visible = false
      this.$emit('back')
    },
    refreshCharges() {
      const jobModel = new RailwayExportJob(this.paramsOfTab)
      if (jobModel.uuid) {
        jobModel.charges = ''
        const loading = getLoading4Cxt(this)
        jobModel.loadJobRelated({ charges: true }).finally(() => {
          loading.close()
        })
      }
    },
    reload() {
      this.currentRow.version = 0
      this.isRefresh = true
      // 重置子表数据
      for (const key in this.currentRow) {
        if (typeof this.currentRow[key] === 'object') {
          this.currentRow[key] = ''
        }
      }
      this.currentRow.isCompleteRow = false
      this.againShow(this.action, this.currentRow)
    },
    // 协作
    cooperationHandler() {
      this.cooperationBranchListDialog.jobUuid = this.paramsOfTab.uuid
      this.cooperationBranchListDialog.job = this.paramsOfTab
      this.cooperationBranchListDialog.orderCenterBranch = this.orderCenterBranch
      this.cooperationBranchListDialog.visible = true
    },
    // 退回
    cooperationReturnHandler() {
      this.$confirm(this.$t('CargoMsg.Cargo_AreYouSureReturn'), this.$t('CargoMsg.Cargo_Tips'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        this.toCooperationReturn()
      }).catch(() => {
        //
      })
    },
    toCooperationReturn() {
      const loading = getLoading4Cxt(this)
      updateState({ jobUuid: this.paramsOfTab.uuid, branchId: this.$store.getters.currentOffice.officeId, statusType: SystemConstants.STATUSTYPE_COOPERATE.code, status: SystemConstants.COOPERATE_STATUS_RETURNED.code }).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_ReturnedSuccess'))
      }).finally(() => {
        loading.close()
      })
    },
    // 委托
    async entrustmentClickHandler() {
      if (!this.currentRow.forwardingAgent) {
        this.$message.warning(this.$t('Message.CheckingConsignation'))
        return
      }
      const company = await Company.getCompanyById(this.currentRow.forwardingAgent) // // 发运代理
      if (company && company.linkedBranchId > 0 && company.linkedBranchId !== this.currentRow.opOffice) { // 内部委托
        // cargo-425 集翊达：委托业务往来关联号为空：只有为委托状态的情况下采取判断
        if (this.btnInfo.btnEntrustment === this.$t('SeaExport.Consignation')) {
          if (this.currentRow.relatedJob) {
            this.$message.warning(this.$t('Message.TicketEntrustedCannotRepetitionDelegate'))
            return
          }
        }
        this.doSendBranchHandler()
      }
    },
    // 发送分公司
    doSendBranchHandler() {
      if (this.btnInfo.btnEntrustment === this.$t('SeaExport.AssociationBusinessInformation')) {
        this.queryTrustFrom()
      } else {
        this.sendBranchHandler()
      }
    },
    // 发送分公司
    async sendBranchHandler(event) {
      if (this.currentRow.relatedJob || !this.currentRow.forwardingAgent) {
        this.$message.warning(this.$t('Message.CheckingConsignation'))
        return
      }
      const company = await Company.getCompanyById(this.currentRow.forwardingAgent)
      if (company) {
        // 检索属于发运代理所属分公司的合作伙伴ID
        queryCompany(1, this.currentRow.opOffice).then(res => this.queryCompanyResultHandler(res))
      }
    },
    // 检索属于发运代理所属分公司的合作伙伴ID
    queryCompanyResultHandler(event) {
      const companyArr = event.data
      if (companyArr && companyArr.length > 0) {
        // 加载联系人
        const company = companyArr[0]
        this.sendBranchWindow.cmpIdx = company.cmpIdx
        this.doSendBranch()
      } else {
        this.$message.warning(this.$t('Message.TheBranchCompanyOfCurrentForwardingAgentDoesNotMaintainACorrespondingPartnerInThePartnership'))
      }
    },
    // 发送分公司
    async doSendBranch() {
      const company = await Company.getCompanyById(this.currentRow.forwardingAgent)
      if (company) {
        const office = await Office.getOfficeById(company.linkedBranchId)
        if (office) {
          this.sendBranchWindow.office = office
          this.sendBranchWindow.title = office.chineseName
          this.sendBranchWindow.checkSalesMapping = this.showdCheckSalesMapping
          this.sendBranchWindow.visible = true
        }
      }
    },
    // 销售change事件
    async userId_changeHandler() {
      const userId = this.sendBranchWindow.userId
      if (userId > 0) {
        await getUserDefaultDepartment({
          category: 'role',
          shape: 'csr',
          userId: userId
        }).then(res => this.getDefaultCsrResult(res))
      } else {
        this.sendBranchWindow.departmentId = 0
        this.sendBranchWindow.userId = 0
      }
    },
    // 客服部门
    async getDefaultCsrResult(event) {
      const dep = event.data
      if (dep) {
        this.sendBranchWindow.departmentId = dep.departmentId
        if (dep.officeUuid) {
          await getOfficeByUuid(dep.officeUuid).then(res => this.officeLoadHandler(res))
        } else {
          this.officeLoadHandler({ data: dep.office })
        }
      } else {
        this.sendBranchWindow.departmentId = 0
        this.sendBranchWindow.departmentOfficeId = 0
      }
    },
    // 加载csr加载dep后加载office后更新业务的客服分公司
    officeLoadHandler(event) {
      const office = event.data
      this.sendBranchWindow.departmentOfficeId = office ? office.officeId : 0
    },
    // 发送分公司保存业务
    async enterSendHandler() {
      // 复制一票新的业务以及更新当前业务的relatedJob放在后端[返回修改后的job]
      const item = {}
      item.deptId = this.$store.getters.currentDeptId
      item.branchId = this.$store.getters.currentOfficeId
      item.anyStr = 'csr' // shape
      item.anyBool = Number(this.context.config.get('isCopySellingCharge')) === 1 // isCopySellingCharge
      item.anyBool2 = Number(this.context.config.get('ChargeSyncNeedConfirm')) === 1 // isCopySellingCharge
      item.anyInteger = this.sendBranchWindow.departmentId // departmentId
      item.anyInteger1 = this.sendBranchWindow.departmentOfficeId // departmentOfficeId
      item.anyInteger2 = this.sendBranchWindow.userId // userId
      item.anyInteger3 = this.sendBranchWindow.cmpIdx // cmpIdx
      item.anyInteger4 = this.sendBranchWindow.office.officeId // officeId
      item.anyStr1 = this.currentRow.uuid
      item.location = this.location
      // 出口转进口
      const loading = getLoading4Cxt(this)
      if (this.currentRow.fba) {
        fbaSaveCloneJob(item).then(res => this.saveCloneResultHandler(res)).catch((err) => {
          loading.close()
        }).finally(() => {
          this.sendBranchWindow.visible = false
          loading.close()
        })
      } else {
        item.checkSalesMapping = this.sendBranchWindow.checkSalesMapping
        if (item.checkSalesMapping) {
          const cloneJob = {
            ...this.currentRow,
            customerId: this.currentRow.forwardingAgent,
            designationAgent: 0,
            opOffice: item.anyInteger4,
            sales: 0,
            salesOffice: 0,
            salesDepartment: 0
          }
          await JobUtils.loadSalesByJob(cloneJob, true)
          item.sales = cloneJob.sales
          item.salesOffice = cloneJob.salesOffice
          item.salesDepartment = cloneJob.salesDepartment
        }
        const excludeFileds = this.sendBranchWindow.userId ? ['csr'] : []
        saveCloneJob(item).then(res => {
          if (res.data && res.data.relatedJob) {
            getRelatedJob({ anyStr: res.data.relatedJob }).then(res2 => {
              JobUtils.matchPresetConfigAndSave(res2.data, excludeFileds)
            })
          }
          this.saveCloneResultHandler(res)
        }).catch((err) => {
          loading.close()
        }).finally(() => {
          this.sendBranchWindow.visible = false
          loading.close()
        })
      }
    },
    async saveCloneResultHandler(res) {
      this.$message.success(this.$t('Message.SuccessfullySent'))
      this.btnInfo.btnEntrustment = this.$t('SeaExport.AssociationBusinessInformation')
      this.sendBranchWindow.userId = 0
      this.sendBranchWindow.cmpIdx = 0
      this.sendBranchWindow.office = {}
      this.sendBranchWindow.departmentId = 0
      this.sendBranchWindow.departmentOfficeId = 0
      //
      this.refresh()
    },
    // 刷新当前业务数据
    refresh() {
      this.currentRow.version = 0
      this.currentRow.isCompleteRow = false
      this.againShow(this.action, this.currentRow)
    },
    // 查看关联业务信息
    queryTrustFrom() {
      if (this.currentRow.relatedJob && this.currentRow.relatedJob.trim()) {
        if (this.currentRow.fba) {
          // job相关的初始化也放在这里面了，统一返回，避免多次访问后端
          fbaGetRelatedJob(this.currentRow.relatedJob).then(res => this.queryTrustResultHandler(res))
        } else {
          // job相关的初始化也放在这里面了，统一返回，避免多次访问后端
          getRelatedJob({ anyStr: this.currentRow.relatedJob }).then(res => this.queryTrustResultHandler(res))
        }
      } else {
        this.$message.warning(this.$t('Message.NoAssociatedBusiness'))
      }
    },
    queryTrustResultHandler(event) {
      const trustJob = event.data
      if (trustJob) {
        // 显示关联业务
        this.trustFromWindow.trustJob = trustJob
        this.trustFromWindow.visible = true
      } else {
        this.$message.warning(this.$t('Message.FailedToQueryTheAssociatedBusiness'))
      }
    },
    // 刷新控制按钮
    updateControlsState() {
      const job = this.currentRow
      if (!job) return
      // 发送分公司控制
      const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', job.forwardingAgent)
      this.privilege.consignationEnable = company && company.linkedBranchId > 0 && company.linkedBranchId !== job.opOffice && !job.relatedJob
      // CARGO-23488 详情页面切换业务，当前业务没有做委托，按钮显示仍会显示“关联进口业务信息”
      this.btnInfo.btnEntrustment = this.$t('SeaExport.Consignation')
      // CARGO-30390上海辰景13900点击出口转进口按钮后，出口转进口按钮依旧会显示
      // relatedJobLob字段只有内部出口转进口时才会有值，如果是跨租户出口转进口，则relatedJobLob等于空
      if (company && !this.privilege.consignationEnable && job.relatedJob && !company.relateTenantId) {
        this.btnInfo.btnEntrustment = this.$t('SeaExport.AssociationBusinessInformation')
        this.privilege.consignationEnable = !this.isEdit
      }
    },
    // im入口值返回
    async getImGroupFunc(paramsOfTab) {
      const result = paramsOfTab.data
      if (!this.imCacheKey || !result || (result && !result.jobNo)) {
        return
      }
      let etdTime = ''
      if (result && result.etd) {
        etdTime = result.etd.slice(0, 10)
      } else {
        etdTime = ''
      }
      console.log('result======', result)
      const imGroupName = `${result.jobNo}-${etdTime}-${ColumnUtils.resolveColumnLabelV2(TYPE_NAMES.basic_data_RailwayStation, 'code', result.destinationStation, 'chineseName')}`
      const userInfo = this.$store.getters.userInfo
      // 销售 揽货销售 海外客服 航线负责人 现场操作 单证 自定义岗位1 自定义岗位2
      const personnel = ['sales', 'cargoSalesId', 'overseaOp', 'planner', 'siteOP', 'dc', 'csr', 'userDefinedRoleId1', 'userDefinedRoleId2', 'op']
      const data = {
        tenantId: userInfo.tenantId,
        cargowareCompanyId: result.customerId, // cargoware的合作伙伴，对应b2b的订舱公司
        loginUserId: userInfo.userId,	// 登陆人userId
        customerEmail: result.contactEmail, // 客户邮箱
        otherUserIdList: [userInfo.userId], // 其他内部人userId，userName
        docId: result.jobNo, // 单据Id
        type: '' // 单据type
      }
      if (!data.customerEmail) {
        await this.loadCustomer(data, result)
      }
      for (const item of personnel) {
        if (result[item]) {
          data.otherUserIdList.push(result[item])
        }
      }
      this.$refs.cargoIm.onShow(data, imGroupName)
    },
    async loadCustomer(data, result) {
      console.log('result.customerId======', result)
      let company = { cmpIdx: result.customerId }
      company = new Company(company)
      const contacts = await company.getContactsBycmpIdx()
      if (contacts) {
        for (const contact of contacts) {
          if (contact.contactPerson === result.customerContact) {
            data.customerEmail = contact.email
            break
          }
        }
      }
    },
    // 审批发起回调
    applyCloseAndRefresh() {
      this.jobApplyDialog.visible = false
      this.currentRow.version = 0
      this.refresh()
    },
    mactchCooperateBranch(cooperateBranch, office) {
      if (cooperateBranch && office) {
        const list = cooperateBranch.split(' | ')
        if (list && list.length > 0) {
          for (const officeName of list) {
            if (officeName === office.chineseName) {
              return true
            }
          }
        }
      }
      return false
    },
    updateJobCooperate(cooperatebranch) {
      this.currentRow.cooperatebranch = cooperatebranch ? cooperatebranch.split(',').join(' | ') : ''
    }
  }
}
</script>

<style scoped lang="scss">
#app .details-view .main-content .tabs-container ::v-deep  {
  .el-tabs--card .el-tabs__header .el-tabs__item {
    border-left: 1px solid #E4E7ED !important;
    margin-left: unset;
  }
}
.operations{
  justify-content: flex-start;
  align-items: center;
  .triggers{
    flex-grow: 0;
  }
  .triggers-right{
    height: 100%;
    line-height: 28px;
    border-left: 2px solid #FFF;
    margin-left: 10px;
    padding-left: 6px;
    white-space: nowrap;
    display: flex;
  }
}
.details-view {
  .btn-group-look.cannot-operate-job::v-deep,
  .tabs-container.cannot-operate-job::v-deep {
    .el-button {
      &.el-button--primary:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #8fbaea;
        border-color: #8fbaea;
      }
      &.el-button--success:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #a1dcc1;
        border-color: #a1dcc1;
      }
      &.el-button--danger:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #fab6b6;
        border-color: #fab6b6;
      }
    }
  }
  .btn-group-look.cannot-operate-job::v-deep {
    .el-dropdown.can-operate {
      .el-button {
        &.el-button--primary {
          pointer-events: auto;
          background-color: #1F75D5;
          border-color: #1F75D5;
          &:focus, &:hover {
            background: #4c91dd;
            border-color: #4c91dd;
          }
        }
      }
    }
  }
}
</style>
